import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input,
  Stack,
  Switch,
  useToast,
} from "@chakra-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import useAuth from "../context/AuthContext";
import jwtService from "./../api/jwt.service";
import styles from "./Hero.module.css";

const Header = () => {
  const {
    dispatch,
    state: { isLowBandwidth: lowBandwidth },
  } = useAuth();

  const [isOpen, setIsOpen] = React.useState(false);
  const { handleSubmit, register } = useForm();
  const [isLowBandwidth, setIsLowBandwidth] = React.useState(lowBandwidth);

  const handleExpandForm = () => {
    setIsOpen(!isOpen);
  };

  const toast = useToast();

  const toggleBandwidth = (value) => {
    setIsLowBandwidth(!isLowBandwidth);
    jwtService.storeItem(value, "isLowBandwidth");
    dispatch({ type: "SET_BANDWIDTH" });
    value &&
      toast({
        title: "Low Bandwidth Mode",
        description: "All images are hidden for better performance",
        duration: 5000,
        position: "top",
      });
    // if (value) {
    //   const imgArr = Array.from(document.querySelectorAll("img#will-hide"));

    //   imgArr.forEach((img) => {
    //     img.style.display = "none";
    //   });

    //   console.log(imgArr);
    // } else {
    //   const imgArr = Array.from(document.querySelectorAll("img#will-hide"));

    //   imgArr.forEach((img) => {
    //     img.style.display = "block";
    //   });
    // }
  };

  const onSubmitHanldler = (values) => {
    setIsOpen(!isOpen);
  };

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      padding={["10px 0px", "15px 30px"]}
      // mt={["60px", "60px", "70px"]}
      bg="#fff"
      color="#000"
      position="fixed"
      top={["3", "3"]}
      left="0"
      w={["100vw", "100%"]}
      zIndex="300"
      borderBottom="2px solid #eee"
      shadow="sm"
      className={styles.Header}
    >
      <Box></Box>
      <Flex
        mr="4"
        align={["flex-end", "center"]}
        direction={["column-reverse", "row"]}
      >
        <form onSubmit={handleSubmit(onSubmitHanldler)}>
          <Stack isInline display={isOpen ? "flex" : "none"}>
            <FormControl w="300px">
              <Input placeholder="Search" ref={register} name="search-param" />
            </FormControl>
            <Button
              bg="#00a551"
              _hover={{ bg: "#00a551", color: "#fff" }}
              color="#fff"
              type="submit"
            >
              <Icon name="search" />
            </Button>
          </Stack>
        </form>
        <Stack isInline ml={["2", "4"]} align="center">
          <Button
            bg="#00a551"
            color="#fff"
            type="button"
            onClick={handleExpandForm}
            display={isOpen ? "none" : "block"}
            _hover={{ bg: "#00a551", color: "#fff" }}
          >
            <Icon name="search" />
          </Button>
          <FormControl
            display="flex"
            alignItems="center"
            alignSelf="flex-end"
            justifySelf="flex-end"
            ml="4"
          >
            <FormLabel htmlFor="low-bandwidth" mb="1">
              Low Bandwidth
            </FormLabel>
            <Switch
              id="low-bandwidth"
              mb="1"
              isChecked={isLowBandwidth}
              onChange={(e) => toggleBandwidth(e.target.checked)}
            />
          </FormControl>
        </Stack>
      </Flex>
    </Flex>
  );
};

export default Header;
